import classNames from "classnames";
import React, { useState } from "react";
import SVG from "react-inlinesvg";
import EmailSVG from "tsi-common-react/img/icons/email-sent.svg";
import Link from "tsi-common-react/src/common/Link";
import urls from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { Image } from "../../../common/Image";
import { IVoucherDiscount } from "../../../models/catalogue.interfaces";

import styles from "./common-full.module.scss";

export const VoucherLineFull = (props: {
    voucherData: IVoucherDiscount;
    onRemoveLine: (code: string) => void;
}): React.ReactNode => {
    const [isSavingsInfoExpanded, setIsSavingsInfoExpanded] = useState(true);
    const toggleAccordion = () => {
        setIsSavingsInfoExpanded((prev) => !prev);
    };
    const basketSavingsID = `voucher-line-savings-details-${props.voucherData.voucher.code}`;
    return (
        <section className={styles.virtualLine}>
            {props.voucherData.desktop_image && (
                <div className={styles.firstColumn}>
                    <Link
                        href={urls.pageURL("how-will-i-receive-my-card")}
                        target="_top"
                    >
                        <Image
                            alt={props.voucherData.name}
                            src={props.voucherData.desktop_image}
                        />
                    </Link>
                </div>
            )}
            <div>
                <h2 className={styles.virtualTitle}>
                    <Link
                        href={urls.pageURL("how-will-i-receive-my-card")}
                        target="_top"
                    >
                        {props.voucherData.name}
                    </Link>
                </h2>
            </div>
            <div className={styles.quantity}>
                <span>
                    {t`Qty:`} &nbsp; {props.voucherData.freq}
                </span>
            </div>
            <div className={styles.virtualLineSavings}>
                <div className={styles.savingSummary}>
                    <button
                        className={classNames({
                            [styles.accordionButton]: true,
                            [styles.accordionButtonExpanded]:
                                isSavingsInfoExpanded,
                        })}
                        aria-controls={basketSavingsID}
                        onClick={toggleAccordion}
                        aria-expanded={isSavingsInfoExpanded}
                    >
                        {t`Total Savings`}
                    </button>
                </div>
                {isSavingsInfoExpanded && (
                    <div className={styles.savingSummary}>
                        <div
                            id={basketSavingsID}
                            className={styles.savingDetails}
                        >
                            {props.voucherData.voucher.code}
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.whiteGloveDelivery}>
                <span className={styles.deliveryText}>
                    <SVG src={EmailSVG} />
                    {t`Gift card redemption instructions sent via email`}
                </span>
            </div>
            <button
                onClick={() =>
                    props.onRemoveLine(props.voucherData.voucher.code)
                }
                className={`${styles.removeButton} al-basket-line__button--remove`}
            >
                {t`[Remove from cart]`}
            </button>
        </section>
    );
};
